import { Typography, styled } from '@mui/material'
import { ReactNode } from 'react'
import { emptyMatchURI, emptyDeclinedURI, emptyMessagesURI } from './Icons'

type ContentType = 'messages' | 'matches' | 'declines'

interface EmptyStateProps {
  contentType: ContentType
  children: ReactNode
}

const getBackgroundURI = (iconType: ContentType): string => {
  if (iconType === 'matches') return emptyMatchURI
  if (iconType === 'declines') return emptyDeclinedURI
  return emptyMessagesURI
}

interface EmptyStateContainerProps {
  backgroundURI: string
}
const EmptyStateContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'backgroundURI',
})<EmptyStateContainerProps>(({ backgroundURI, theme }) => ({
  ...(backgroundURI
    ? {
        background: `url("data:image/svg+xml, ${backgroundURI}") no-repeat center center`,
        backgroundSize: 'auto 100%',
        minHeight: 350,
        [theme.breakpoints.up('md')]: {
          minHeight: 400,
        },
        [theme.breakpoints.up('lg')]: {
          minHeight: 450,
        },
      }
    : {}),
  marginTop: '24px',
  textAlign: 'center',
}))
interface EmptyStateTextProps {
  contentType?: ContentType
}
const EmptyStateText = styled(Typography, {
  shouldForwardProp: (propName) => propName !== 'contentType',
})<EmptyStateTextProps>(({ contentType, theme }) => ({
  position: 'relative',
  margin: '0 auto',
  left: contentType === 'messages' ? '15px' : '0px',
  textAlign: 'center',
  top: 15,
  [theme.breakpoints.up('md')]: {
    top: 30,
  },
  [theme.breakpoints.up('lg')]: {
    top: 45,
    width: '16.25rem',
  },
  width: contentType === 'messages' ? '16.25rem' : '12rem',
}))

const EmptyState = ({
  children,
  contentType,
}: EmptyStateProps): JSX.Element => (
  <EmptyStateContainer backgroundURI={getBackgroundURI(contentType)}>
    <EmptyStateText>{children}</EmptyStateText>
  </EmptyStateContainer>
)

export default EmptyState
